module.exports = __webpack_public_path__ + "static/img/breadcrumb.310eaa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/breadcrumb.jpg
// module id = OmrO
// module chunks = 1